











import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Panel extends Vue {
  @Prop() private color!: string;
  @Prop() private title!: string;
  @Prop() private margin!: string;
  get style() {
    return `background-color: ${this.color}`;
  }
  get title_style() {
    return `margin-top: ${this.margin}`;
  }
}

